import { faCheckCircle, faChevronDown, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActionDialog from "components/reusable/ActionDialog";
import BottomSheet from "components/reusable/BottomSheet";
import ErrorMessage from "components/reusable/ErrorMessage";
import OtpDialog from "components/reusable/OtpDialog";
import Toolbar from "components/Toolbar";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import AddWalletBottomSheet from "../AddWallet/AddWalletBottomSheet";

function TransferWallets() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notification = useToastContext();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [fromWallet, setFromWallet] = useState(null);
  const [toWallet, setToWallet] = useState(null);
  const [loading, setLoading] = useState(false);
  const [requestBody, setRequestBody] = useState({});
  const { wallets, getProfile } = useContext(AuthContext);

  const [showSelectWalletBottomSheet, setShowSelectWalletBottomSheet] = useState(false);
  const [selectWalletContext, setSelectWalletContext] = useState("");

  const [noSecondWallet, setNoSecondWallet] = useState(false);
  const [showCreateWalletBottomSheet, setShowCreateWalletBottomSheet] = useState(false);

  const [showOtpDialog, setShowOtpDialog] = useState(false);

  useEffect(() => {
    if (wallets.length <= 1) {
        setNoSecondWallet(true)
        return
    }
    if (wallets) {
      selectWallet(wallets[0]._id, "from");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wallets]);

  const selectWallet = (id, context) => {
    switch (context) {
      case "from":
        var from = wallets[wallets.findIndex((it) => it._id === id)];
        setFromWallet(from);

        if (toWallet == null || toWallet._id === from._id) {
          var to = wallets.find((it) => it._id !== from._id);
          setToWallet(to);
        }

        break;
      case "to":
        var tw = wallets[wallets.findIndex((it) => it._id === id)];
        setToWallet(tw);

        if (fromWallet == null || fromWallet._id === tw._id) {
          var fw = wallets.find((it) => it._id !== tw._id);
          setToWallet(fw);
        }
        break;
      default:
        break;
    }
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const requestBody = {
        amount: data.amount,
        description: data.description,
        sender_wallet_id: fromWallet._id,
        receiver_wallet_id: toWallet._id,
        transferType: "wallet_to_wallet",
      };
      setRequestBody(requestBody);
      const res = await apiPost(pathObj.transferOTP, requestBody);
      if (res.data.success) {
        setShowOtpDialog(true);
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <Toolbar title={t("TRANSFER_BETWEEN_ACCOUNTS")} showBackBtn={true} />
      {noSecondWallet && (
        <ActionDialog
          open={noSecondWallet}
          title={t("WARNING")}
          positiveText={t("ADD_WALLET")}
          onPositive={() => {
            setNoSecondWallet(false);
            setShowCreateWalletBottomSheet(true);
          }}
          negativeText={t("BACK")}
          onNegative={() => {
            navigate(-1);
          }}
          onClose={() => {
            navigate(-1);
          }}
        >
          <div className="w-full flex items-center justify-center">
            <h4 className="font-medium">{t("add_wallet_to_use_feature")}</h4>
          </div>
        </ActionDialog>
      )}
      {showCreateWalletBottomSheet && (
        <AddWalletBottomSheet
          open={showCreateWalletBottomSheet}
          onCreate={() => {
            setShowCreateWalletBottomSheet(false);
            getProfile()
          }}
          onClose={() => {
            navigate(-1);
          }}
        />
      )}
      {showSelectWalletBottomSheet && (
        <BottomSheet
          open={showSelectWalletBottomSheet}
          title={t("SELECT_WALLET")}
          onClose={() => {
            setShowSelectWalletBottomSheet(false);
          }}
        >
          {wallets.map((it) => (
            <div
              key={it._id}
              className="bg-card p-4 flex justify-start items-center gap-3 mb-3 cursor-pointer"
              onClick={() => {
                selectWallet(it._id, selectWalletContext);
                setShowSelectWalletBottomSheet(false);
              }}
            >
              {selectWalletContext === "from" && fromWallet._id === it._id ? <FontAwesomeIcon icon={faCheckCircle} className="card-icon" size="xl" /> : <></>}
              {selectWalletContext === "to" && toWallet._id === it._id ? <FontAwesomeIcon icon={faCheckCircle} className="card-icon" size="xl" /> : <></>}
              <div>
                <h4 className="text-lg font-medium text-white">{it.wallet_description || "-"}</h4>
                <span className="font-medium text-white">
                  {t("AMOUNT")} {it.wallet_currency} {it.wallet_amount}
                </span>
              </div>
            </div>
          ))}
        </BottomSheet>
      )}
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col w-full justify-center items-center">
        <div className="mt-3 p-4 rounded-3xl h-full w-full md:w-[25rem]">
          <div className="mt-2 mx-2">
            <div className="text-lg font-medium mt-5 mb-2">{t("FROM")}</div>
            <div
              className="bg-card p-4 rounded-lg"
              onClick={() => {
                if (fromWallet) {
                  setShowSelectWalletBottomSheet(true);
                  setSelectWalletContext("from");
                }
              }}
            >
              <div className="flex justify-between items-center cursor-pointer">
                <div>
                  <h4 className="text-lg font-medium text-white">{fromWallet?.wallet_description || "-"}</h4>
                  {fromWallet && (
                    <span className="font-medium text-white">
                      {t("AMOUNT")} {fromWallet.wallet_currency} {fromWallet.wallet_amount}
                    </span>
                  )}
                </div>
                <FontAwesomeIcon icon={faChevronDown} className="text-white" />
              </div>
            </div>

            <div className="text-lg font-medium mt-5 mb-2">{t("TO")}</div>
            <div
              className="bg-card p-4 rounded-lg"
              onClick={() => {
                if (toWallet) {
                  setShowSelectWalletBottomSheet(true);
                  setSelectWalletContext("to");
                }
              }}
            >
              <div className="flex justify-between items-center">
                <div>
                  <h4 className="text-lg font-medium text-white">{toWallet?.wallet_description || "-"}</h4>
                  {toWallet && (
                    <span className="font-medium text-white">
                      {t("AMOUNT")} {toWallet.wallet_currency} {toWallet.wallet_amount}
                    </span>
                  )}
                </div>
                <FontAwesomeIcon icon={faChevronDown} className="text-white" />
              </div>
            </div>

            <div className="text-lg font-medium  mt-5 mb-2">{t("AMOUNT")}</div>
            <div className="bg-card p-4 rounded-lg">
              <div className="flex justify-start gap-3 items-center">
                <div className="font-medium text-lg text-white">{fromWallet?.wallet_currency || "ALL"}</div>
                <input
                  type="number"
                  id="amount"
                  inputType="numeric"
                  className="inputform border-0 text-heading text-white font-medium text-sm rounded-base block w-full px-3 rounded-lg py-2.5 shadow-xs placeholder:text-body"
                  placeholder={t("AMOUNT_FIELD")}
                  onKeyDown={(e) => {
                    e.target.value = e.target.value.trim();
                  }}
                  {...register("amount", {
                    required: t("AMOUNT_EMPTY"),
                  })}
                  required
                />
              </div>
            </div>
            <ErrorMessage message={errors?.amount?.message} />

            <div className="text-lg font-medium  mt-5 mb-2">{t("DESCRIPTION")}</div>
            <input
              type="text"
              id="description"
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
              onKeyDown={(e) => {
                e.target.value = e.target.value.trim();
              }}
              {...register("description", {
                required: "",
              })}
            />

            <div className="w-full mt-[5rem]">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("CONFIRM")}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>

      {showOtpDialog && (
        <OtpDialog
          otpURL={pathObj.transferOTP}
          otpConfirmURL={pathObj.transferBetweenWallets}
          body={requestBody}
          onSuccess={(message) => {
            navigate("/dashboard");
            notification.success(message || t("OPERATION_SUCCESS"));
          }}
          onClose={() => {
            setShowOtpDialog(false);
          }}
        />
      )}
    </>
  );
}

export default TransferWallets;
